<template>
    <div v-if="isVisible">
        <slot
            :answer="$get(answersByPersons, personKey + '.' + question.uuid)"
            :person-key="personKey"
            :person-name="showNames ?
                (!person || (!person.firstname && !person.lastname) ?
                    (changeWordingRegistrationBuy ?
                        $t('eventRegistration.participant.personNumber') : (isCaregiver ?
                            $t('eventRegistration.participant.caregiverNumber') : $t('eventRegistration.participant.participantNumber')))
                    + (index + 1) :
                    (person.firstname ? person.firstname : '') +
                    (person.firstname && person.lastname ? ' ' : '') +
                    (person.lastname ? person.lastname : '')
                ) : null"
            :person="person" />
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import {RuleBuilderEvaluator} from '@farbcodegmbh/amosweb-rulebuilder'
import ruleBuilderComparisionElementsMixin from "@/mixins/registration/ruleBuilderComparisionElementsMixin";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import registrationCaregiverMixin from "@/mixins/registration/registrationCaregiverMixin";

export default {
    name: "PersonWrapper",
    mixins: [mainRegistrationMixin, registrationCaregiverMixin, ruleBuilderComparisionElementsMixin, registrationOnlineRegistrationFieldsMixin],
    props: {
        personKey: {
            type: [String, Number],
            required: true
        },
        question: {
            type: Object,
            required: true
        },
        answersByPersons: {
            type: Object,
            required: true
        },
        showNames: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        registrarMode: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isVisible() {
            if (!this.question.visibilityConditions) {
                return true
            }
            const evaluator = new RuleBuilderEvaluator(
                {
                    ...this.getRegistrarQuestionsForRuleBuilderEvaluator,
                    ...this.registrarMode && this.getRegistrarRegistrationDateForRuleBuilder,
                    ...this.registrarMode && this.getRegistrationTypeForRuleBuilder,
                    ...!this.registrarMode && this.getParticipantQuestionsForRuleBuilderEvaluator,
                    ...!this.registrarMode && this.getParticipantDataForRuleBuilderEvaluator
                },
                false
            )
            return evaluator.evaluateRule(this.question.visibilityConditions)
        },
        getParticipantQuestionsForRuleBuilderEvaluator() {
            return this.getQuestionsForRuleBuilderEvaluator(this.personKey)
        },
        getParticipantDataForRuleBuilderEvaluator() {
            return this.getPersonDataForRuleBuilderEvaluator(this.personKey)
        },
        person() {
            return this.registrationData.persons[this.personKey]
        }
    },
    watch: {
        isVisible: {
            handler(isVisible) {
                this.$emit('setQuestionGlobalVisibilityForPerson', {
                    personKey: this.personKey,
                    isVisible: isVisible
                })

                //If Question is not visible clear answer
                if (!isVisible) {
                    this.$emit('event', {
                        answer: [],
                        personKey: this.personKey,
                        questionUuid: this.question.uuid
                    })
                }

            },
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>
